<template>
	<div>
		<erji-title :titleName="this.titleName" :fatherName="this.fatherName"></erji-title>
		<div class="erji-content">
			<div class="danpian">
				<div class="danpian-h1">{{content.title}}</div>
				<div class="danpian-h2">作者：{{content.author}} &nbsp 发布时间：{{content.created_at.slice(0,10)}} &nbsp <div id="share-2" style="display: inline-block;"></div></div>
				<div class="danpian-con" v-html="content.body">
				</div>
				<div class="dan-page">
					<div class="dan-a" v-if="this.prev_title != ''">
						<div class="dan-a_span" @click="go_pnLink(prev_id)">上一篇：{{prev_title}}</div>
					</div>
					<div class="dan-a" v-if="this.next_title != ''">
						<div class="dan-a_span" @click="go_pnLink(next_id)">下一篇：{{next_title}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../../assets/js/jquery.share.min.js';
	export default {
	  name: 'detail',
		data(){
			return{
				titleName:'',
				fatherName:'',
				id:'',
				category_id:'',
				content:{
					author:'',
					created_at:'',
					hit:'',
					body:''
				},
				prev_title:"",
				prev_id:"",
				next_title:"",
				next_id:"",
				
			}
		},
		methods:{
			//请求分类信息
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
								this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求父类信息
			res_fatherClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log('response090',response)
								this.fatherName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求详情
			res_detail(e){
				this.axios.get('/api/news/newsView?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.content = response.data.reslut;
							this.content.body = response.data.reslut.body.replace(
								/<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
								(match, path) => {
									return path.search("http") == -1
										? `<img src='${this.imgURL}${path}' />`
										: match;
								}
							);
							this.id = response.data.reslut.id;
							this.prev_id = response.data.reslut.pre_id;
							this.next_id = response.data.reslut.next_id;
							this.res_detail_p()
							this.res_detail_n()
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求兄弟内容
			res_detail_p(){
				if(this.prev_id != '' && this.prev_id != null){
					this.axios.get('/api/news/newsView?id='+this.prev_id)
						.then(response => {
							// 处理成功情况
							if(response.data.code == 200){
								// console.log(response.data.reslut)
								this.prev_title = response.data.reslut.title;
							}else{
								this.prev_title = ''
							}
						})
						.catch(error => {
							// 处理错误情况
							console.log(error);
						})
				}else{
					console.log('上一篇没了')
				}
			},
			res_detail_n(){
				if(this.next_id != '' && this.next_id != null){
					this.axios.get('/api/news/newsView?id='+this.next_id)
						.then(response => {
							// 处理成功情况
							if(response.data.code == 200){
								// console.log(response.data.reslut)
								this.next_title = response.data.reslut.title;
							}else{
								this.next_title = ''
							}
						})
						.catch(error => {
							// 处理错误情况
							console.log(error);
						})
				}else{
					console.log('下一篇没了')
				}
			},
			//跳转兄弟链接
			go_pnLink(e){
				if(e){
					this.$router.push({
						path:'/slider/'+ this.content.parent_id +'/detail',
						query:{
							category_id:this.content.category_id,
							id:e
						}
					})	
				}else{
					console.log('???')
				}
			}
		},
		created() {
			this.id = this.$route.query.id;
			this.category_id = this.$route.query.category_id
			this.res_menusClass(this.category_id);
			this.res_fatherClass(this.$route.params.id)
			this.res_detail(this.id);
		},
		watch :{
			'$route' (to, from) {
					// 对路由变化作出响应...
					// console.log("to",to);
					// console.log("from",from);
					this.id = to.query.id;
					this.prev_title= "";
					this.next_title= "";
					this.res_detail(this.id);
			}
		},
		mounted(){
			
			this.$nextTick(() => {
				$('#share-2').share({sites: ['qzone', 'qq', 'weibo','wechat']});
			})
		}
	}
</script>

<style>
</style>